/* 🤖 this file was generated by svg-to-ts */
export const matIconAudiotrack: {
  name: 'audiotrack';
  data: string;
} = {
  name: 'audiotrack',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6zm-2 16c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"/></svg>`
};
